module.exports = __webpack_public_path__ + "img/logo_b.a1f5a0d5.webp";